<template>
  <div class="row">
    <div class="col-xs-12">
      <div class="form-field select2">
        <div class="select2-field">
          <v-select
            @search="onSearchGeocercas"
            placeholder="Realice una consulta..."
            id="geocerca"
            v-model="selectedGeocercaExistente"
            label="nombre"
            :options="geocercasExistentes"
            @input="inputGeocerca"
          ></v-select>
          <label for="geocerca">Geocerca</label>
        </div>
      </div>
    </div>
    <div class="col-xs-12">
      <div style="max-height: 300px" class="table-responsive">
        <table>
          <thead>
            <tr>
              <th>Descripción</th>
              <th>Latitud</th>
              <th>Longitud</th>
              <th>Radio</th>
              <th>
                <button type="button" @click="agregar" class="btn-success">
                  <i class="fa fa-plus"></i>
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(geocerca, index) in geocercas" :key="index">
              <td>
                {{ geocerca.descripcion }}
              </td>
              <td>
                {{ geocerca.latitud }}
              </td>
              <td>
                {{ geocerca.longitud }}
              </td>
              <td>
                {{ geocerca.radio }}
              </td>
              <td>
                <button
                  type="button"
                  @click="editar(index)"
                  class="btn-info btn--text"
                >
                  <i class="fa fa-edit"></i>
                </button>
                <button
                  class="btn-primary btn--text"
                  type="button"
                  @click="verGeocerca(index)"
                >
                  <i class="fa fa-eye"></i>
                </button>
                <button
                  type="button"
                  @click="eliminar(index)"
                  class="btn-danger btn--text"
                >
                  <i class="fa fa-times"></i>
                </button>
              </td>
            </tr>
            <tr v-show="geocercas.length === 0">
              <td colspan="5">
                <strong>No se ha agregado geocercas.</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <modal
          name="geocerca"
          height="auto"
          width="60%"
          scrollable
          adaptive
          reset
          resizable
        >
          <geocerca
            @aceptar="aceptar"
            @cancelar="cancelar"
            v-model="selectedGeocerca"
          ></geocerca>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import Geocerca from "./Geocerca.vue";
export default {
  components: {
    Geocerca,
  },
  props: {
    value: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    inputGeocerca: function () {
      if (this.selectedGeocercaExistente != null) {
        let coordinates =
          this.selectedGeocercaExistente.coordenadas_geocerca.coordinates;
        let existe = false;
        for (let i = 0; i < this.geocercas.length; i++) {
          if (
            this.geocercas[i].latitud == coordinates[1] &&
            this.geocercas[i].longitud == coordinates[0]
          ) {
            existe = true;
            break;
          }
        }
        if (!existe) {
          let index =
            this.geocercas.push({
              descripcion: this.selectedGeocercaExistente.descripcion,
              radio: this.selectedGeocercaExistente.radio,
              latitud: coordinates[1],
              longitud: coordinates[0],
              latLng: [coordinates[1], coordinates[0]],
            }) - 1;
          this.verGeocerca(index);
        }
        setTimeout(() => {
          this.selectedGeocercaExistente = null;
        }, 500);
      }
    },
    onSearchGeocercas: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.geocercasExistentes = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/geocercas?tipo=S&search=" + search,
        true
      );
      xmlhttp.send();
    },
    verGeocerca: function (index) {
      this.$emit("verGeocerca", index);
    },
    eliminar: function (index) {
      this.geocercas.splice(index, 1);
    },
    aceptar: function (geocerca) {
      this.nuevaGeocerca = false;
      this.geocercas.splice(this.selectedIndex, 1, geocerca);
      this.verGeocerca(this.selectedIndex);
      this.$modal.hide("geocerca");
    },
    cancelar: function () {
      if (this.nuevaGeocerca) {
        this.geocercas.splice(this.selectedIndex, 1);
      }
      this.$modal.hide("geocerca");
    },
    agregar: function () {
      this.nuevaGeocerca = true;
      let geocerca = {
        descripcion: "",
        latitud: -2.1408961,
        longitud: -79.9080648,
        radio: 100,
        latLng: [-2.1408961, -79.9080648],
      };
      this.selectedIndex = this.geocercas.push(geocerca) - 1;
      this.selectedGeocerca = JSON.parse(JSON.stringify(geocerca));
      this.$modal.show("geocerca");
    },
    editar: function (index) {
      this.nuevaGeocerca = false;
      this.selectedGeocerca = JSON.parse(JSON.stringify(this.geocercas[index]));
      this.selectedIndex = index;
      this.$modal.show("geocerca");
    },
  },
  data: function () {
    return {
      geocercasExistentes: [],
      geocercas: this.value,
      selectedGeocerca: null,
      nuevaGeocerca: false,
      selectedIndex: -1,
      selectedGeocercaExistente: null,
    };
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/rutas/PuntosGeocercas.vue